import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { HOLD_AREA_1 } from "@/constants/warehouse"
import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletCurrentLocationCellProps {
  pallet: GoodsReceiptPallet
}

export const GoodsReceiptPalletCurrentLocationCell: FC<GoodsReceiptPalletCurrentLocationCellProps> = ({ pallet }) => {
  if (!pallet.isStored) {
    return <Typography variant='body2'>{HOLD_AREA_1}</Typography>
  }

  // If pallet is stored, show the actual location (Aisle/Shelf/Bin)
  // Handle unmanaged destination case
  if (pallet.goodsReceiptPalletRow?.unmanagedDestination) {
    return <Typography variant='body2'>{pallet.goodsReceiptPalletRow.unmanagedDestination}</Typography>
  }
  const location = pallet.destinationWarehouseShelving

  return (
    <Box className='flex flex-col'>
      <Typography variant='h6'>Aisle: {location?.aisleCode ?? "-"}</Typography>
      <Typography variant='subtitle2'>Shelf: {location?.sectionCode ?? "-"}</Typography>
      <Typography variant='subtitle2'>Bin: {location?.binNumber ?? "-"}</Typography>
    </Box>
  )
}
